export default __webpack_public_path__ + "static/media/world.696c5a87.svg";